import createComposition from './composition';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import PrivacyRibbon
  from './presentation/components/privacy-ribbon/ConnectedPrivacyRibbon';
import InlinePrivacy from './presentation/components/inline-privacy/ConnectedInlinePrivacy';
import PrivacyModal from './presentation/components/privacy-modal/ConnectedPrivacyModal';
import * as r from 'ramda';
import browserCookies from 'browser-cookies';
import uuid from 'uuid/v4';

export function privacyManager(config) {
  const patchedConfig = r.pipe(
    r.mergeDeepWith(r.concat, r.__, {
      cookiesToPreserve: [],
    }),
    r.mergeDeepRight(r.__, {
      locale: 'en',
      // cookiesToPreserve: [],
      waitForTealium: false,
      theme: {
        palette: {
          grey01: '#1a1a1a',
          grey02: '#282828',
          grey03: '#333',
          grey04: '#484848',
          grey05: '#666',
          grey06: '#848484',
          grey07: '#909090',
          grey08: '#999',
          grey09: '#ccc',
          grey10: '#eee',
          grey11: '#f2f2f2',
          grey12: '#f7f7f7',

          red01: '#cc0000',
          red02: '#f4c7c7',

          yellow01: '#EDD000',
          yellow02: '#FAF1B2',

          green01: '#7FA800',
          green02: '#D8E5B2',
        },
      },
    }),
  )(config);

  const forcedStyles = (context) => `
${context} * {
  box-sizing: border-box;
}
${context} button {
  min-width: auto;
  border-radius: 0;
}
  `;

  function run() {
    const {
      store,
      init,
    } = createComposition({
      config: patchedConfig,
    });

    init();

    if (patchedConfig.bannerDomSelector != null) {
      const banner = document.querySelector(patchedConfig.bannerDomSelector);
      if (banner) {
        window.addEventListener('unload', () => {
          if(navigator.sendBeacon != null) {
            if(browserCookies.get('pwinteraction') == null) {
              const data = `v=1&t=event&tid=${CONFIG.analytics.tracker}&cid=${uuid()}&aip=1&ec=Consent&ea=ignored&el=ribbon`;
              navigator.sendBeacon('https://www.google-analytics.com/collect', data);
            }
          }
        });

        render(
          (
            <Provider store={store}>
              <IntlProvider
                locale={patchedConfig.locale}
                messages={patchedConfig.messages}
              >
                <div>
                  <style>{forcedStyles('.UPM__PrivacyRibbon')}</style>
                  <PrivacyRibbon
                    theme={patchedConfig.theme}
                    categories={patchedConfig.categories}
                    privacyPolicyUrl={patchedConfig.privacyPolicyUrl}
                  />
                </div>
              </IntlProvider>
            </Provider>
          ),
          banner,
        );
      }
    }

    if (patchedConfig.inlineDomSelector != null) {
      const inline = document.querySelector(patchedConfig.inlineDomSelector);
      if (inline) {
        render(
          (
            <Provider store={store}>
              <IntlProvider
                locale={patchedConfig.locale}
                messages={patchedConfig.messages}
              >
                <div>
                  <style>{forcedStyles('.UPM__InlinePrivacy')}</style>
                  <InlinePrivacy
                    theme={patchedConfig.theme}
                    categories={patchedConfig.categories}
                  />
                </div>
              </IntlProvider>
            </Provider>
          ),
          inline,
        );
      }
    }

    const isOnPrivacyPage = patchedConfig.privacyPolicyUrl != null && window.location.href === patchedConfig.privacyPolicyUrl;
    if (patchedConfig.modalDomSelector != null && isOnPrivacyPage === false) {
      const modal = document.querySelector(patchedConfig.modalDomSelector);
      if (modal) {
        render(
          (
            <Provider store={store}>
              <IntlProvider
                locale={patchedConfig.locale}
                messages={patchedConfig.messages}
              >
                <div>
                  <style>{forcedStyles('.UPM__PrivacyModal')}</style>
                  <PrivacyModal
                    theme={patchedConfig.theme}
                    isOpen={true}
                    privacyPolicyUrl={patchedConfig.privacyPolicyUrl}
                  />
                </div>
              </IntlProvider>
            </Provider>
          ),
          modal,
        );
      }
    }
  }

  function waitForTealium(cb) {
    if (patchedConfig.waitForTealium === true) {
      const poll = setInterval(function() {
        if (window.utag == null) {
          return;
        }
        clearInterval(poll);
        cb();
      }, 100);
    } else {
      cb();
    }
  }

  waitForTealium(run);
}

export default null;

setTimeout(function() {
  // The idea being here that the parent page
  // is able to load in the script as an async to
  // be non-blocking. However, if this is
  // done then the parent page would have no idea
  // when to interact with the script. Therefore,
  // we emit an even to listen to to being operations
  const loadedEvent = document.createEvent('CustomEvent');
  loadedEvent.initCustomEvent('@upm/loaded', false, false, {});
  document.dispatchEvent(loadedEvent);
}, 0);



// WEBPACK FOOTER //
// ./src/main.js